<template>
	<div class="pl10px pr10px" v-loading="loadingstatus" element-loading-text="加载中">
		<table class="table mb0px table-striped table-bordered">
			<thead>
				<tr>
					<th class="text-center" colspan="7">设备基本信息</th>
					<th class="text-center" colspan="4">SIM卡信息</th>
					<th class="text-center" colspan="3">设备安装信息</th>
					<th></th>
				</tr>
				<tr>
					<th></th>
					<th v-for="thead in theadList">{{thead}}</th>
					<th></th>
				</tr>
			</thead>
			<tbody>
				<tr v-for="(fileInfo,index) in orgList" v-bind:key="index">
					<td>
						<a v-if="fileInfo.isenable==1" :style="{ color: fileInfo.mainFlag===1?'#d9534f':'#337ab7'}" @click='setMaster(fileInfo.mainFlag,fileInfo.id)'>{{fileInfo.mainFlag===1?'主设备':'设为主设备'}}</a>
					</td>	
					<td>VD{{fileInfo.id}}</td>
					<td>{{fileInfo.deviceNum}}</td>
					<td>{{fileInfo.brandName}}</td>
					<td>{{fileInfo.categoryName}}</td>
					<td>{{fileInfo.obdFlagName}}</td>
					<td>{{fileInfo.wifiFlagName}}</td>
					<td>{{fileInfo.simNum}}</td>
					<td>{{fileInfo.activeDate}}</td>
					<td>{{fileInfo.payPeriodName}}</td>
					<td>{{fileInfo.paymentModeName}}</td>
					<td>{{fileInfo.installer}}</td>
					<td>{{fileInfo.installDate}}</td>
					<td>{{fileInfo.installTypeName}}</td>
					<td class="text-center">
						<!--<a v-if="disEnableFlag(fileInfo,orgList)" @click="setEnable(fileInfo.id,fileInfo.isenable)">停用</a>
						<a v-if="enableFlag(fileInfo,orgList)" @click="setEnable(fileInfo.id,fileInfo.isenable)">启用</a>-->
						<a v-if="fileInfo.isenable==0" @click="removeDevice(fileInfo.id,fileInfo.isEnable)">删除</a>
						<!--<a v-if="permission.indexOf('carFileList_deviceInfoDetail') == -1" @click="addTab(fileInfo.id,fileInfo.deviceNum,fileInfo.obdFlagName)">详细</a>-->
					</td>
				</tr>
			</tbody>
		</table>
	</div>
</template>
<script>
	import { OPERATE_EXCEPTION ,OPERATE_SUCCESS,DELETE_NO} from 'static/message'
	export default {
		name: 'DetailDevice',
		data() {
			return {
				permission:this.$store.state.permission.permission["carFileList"]?this.$store.state.permission.permission["carFileList"]:[],
				loadingstatus:false,
				vehicleInfo: {},
				orgList: [], //表格数据列表
				theadList: ['设备ID', '设备编码', '品牌', '型号', '设备类型', '有线无线', '卡号', '激活日期', '代缴期限', '缴费类型', '安装人', '安装时间', '安装方式']
			}
		},
		beforeMount() {
			Object.assign(this.vehicleInfo, this.$parent.vehicleInfo);
			this.getTableInfo();
		},
		methods: {
			disEnableFlag:function(item,all){
				// 已经停用的不显示停用按钮
				if(item.isenable==0) return false;
				let count=0;
				for(let i =0 ;i<all.length ;i++){
					if(all[i].isenable==1)
					count++;
				}
				if(count<2)
				return false;
				return true;
			},
			enableFlag:function(item,all){
				//
				if(item.isenable ==1) return false;
				return true;
				
				
			},
			addTab: function(val,no,type) {
				const deviceid = val
				const obj = {
					name: deviceid + "-设备详情",
					id: 'PageDeviceDetail',
					route: '/indexhome/deviceDetail'+deviceid,
					No: 'device'+deviceid,
					params:{deviceid: deviceid,vehicleid:this.vehicleInfo.vehicleId,devicenum:no,devicetype:type}
				}
				this.$router.push({path:'/indexhome/deviceDetail'+ deviceid,query:{deviceid: deviceid,vehicleid:this.vehicleInfo.vehicleId,devicenum:no,devicetype:type}});
				this.$store.dispatch('addTab', obj);
			},
			//获取设备信息
			getTableInfo() { 
				this.loadingstatus = true;
				this.$http.get(process.env.API_ROOT + "/vehicle/vehicles/" + this.vehicleInfo.vehicleId +"/devices")
				.then( res => {
					if(res.data.success){
						this.orgList = res.data.data;
					} else {
						this.$parent.openModal(res.data.message);
					}
					this.loadingstatus = false;
				}, res => {
					this.$parent.openModal(res.data.message);
					this.loadingstatus = false;
				}).catch( res => {
					this.$parent.openModal(OPERATE_EXCEPTION);
					this.loadingstatus = false;
				})
			},
			//设置主设备
			setMaster(val,id){
				if (val===1){
					return;
				}
				this.$http.put(process.env.API_ROOT + '/vehicle/vehicles/' + this.vehicleInfo.vehicleId + '/devices',id )
				.then( res => {
					if(res.body.success){
						this.$parent.openModal(OPERATE_SUCCESS);
						this.getTableInfo();
					} else {
						this.$parent.openModal(res.body.message);
					}
				}, res => {
					this.$parent.openModal(res.body.message);
				}).catch( res => {
					this.$parent.openModal(OPERATE_EXCEPTION);
				})
			},
			//启用停用
			setEnable(devicedid,enable){
				let isEnable;
				if (enable==1){
					isEnable=0;
				}
				if (enable==0){
					isEnable=1;
				}
				let param={
					deviceId:devicedid,
					isEnable:isEnable,
					vehicleId:this.vehicleInfo.vehicleId
				}
				this.$http.put(process.env.API_ROOT + '/vehicle/vehicles/' + this.vehicleInfo.vehicleId + '/devices/status',param)
				.then( res => {
					if(res.body.success){
						this.$parent.openModal(OPERATE_SUCCESS);
						this.getTableInfo();
					} else {
						this.$parent.openModal(res.body.message);
					}
				}, res => {
					this.$parent.openModal(res.body.message);
				}).catch( res => {
					this.$parent.openModal(OPERATE_EXCEPTION);
				})
			},
			//设备删除
			removeDevice(devicedid,enable){
				this.$http.put(process.env.API_ROOT + '/vehicle/vehicles/' + this.vehicleInfo.vehicleId + '/devices/'+devicedid+'/isdel')
				.then( res => {
					if(res.body.success){
						this.$parent.openModal(OPERATE_SUCCESS);
						this.getTableInfo();
					} else {
						this.$parent.openModal(res.body.message);
					}
				}, res => {
					this.$parent.openModal(res.body.message);
				}).catch( res => {
					this.$parent.openModal(OPERATE_EXCEPTION);
				})
			}
		}
	}
</script>


// WEBPACK FOOTER //
// DetailDevice.vue?5ce6b810